


export class CustomerType {
    CustomerTypeId: number;
    CompanyId: number;
    CustomerType: string;
    Description: string;
    IsActive: number;
    InActive: boolean;
    CreatedBy: number;
    LastChangedBy: number;
    IsSystemDefined: number;
    IsNetwork: number;
    Status: string;
    PriorityId: number;
    DispatchBoardAccess: any;
    LiveMapAccess: any;
    DashboardAccess: any;
    LogoPath: string;
    CustomerPortalAccess: any;
    IsClinetOrderAutoSchedule: any;
    IsAutoAuthorize: any;
    HolidayTemplateId: number;
    CustomerTypeNo:string;
}

export class ClientPortalWorkType {
    ClientPortalWorkTypeId: number;
    CompanyId: number;
    CustomerTypeId: number;
    WorkTypeId: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
}
export class CustomerTypeSaveEntity {
    CustomerTypeEntity: CustomerType;
    AllotedWorkTypes: ClientPortalWorkType[];
}

export class CustomerTypeBusinessHour {
    CustomerTypeBusinessHourId: number;
    CompanyId: number;
    CustomerTypeId: number;
    WeekDay: any;
    DayStartHour: string;
    DayEndHour: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    Is24Hour: any;
    DayStartHourTag: string;
    DayEndHourTag: string;
}
//Added By Arumugam 15-Feb-2019 For CustomerTypesExcelDownload
export class FilterDetailsEntity {
    constructor(public FilterName: string,
        public FilterValue: string) { }
}
export class CustomerTypesFilterEntity {
    CustomerTypesEntity: CustomerTypes[];
    Filters: FilterDetailsEntity[];
    LoginId: number;
    CompanyId: number;
    ColumnNames: string;
}
export class CustomerTypes {

    CustomerTypeId: number;

    CompanyId: number;

    CustomerType: string;

    Description: string;

    IsActive: number;

    IsSystemDefined: number;

    IsNetwork: number;

    Status: string;
}

export class CustomerTypeList {
    CustomerType: CustomerType[];
    TotalRecord: number;
}

export class CustomerTypeStatus {

    Search: string;

    Status: boolean;


}
export class WorkType {
    WorkTypeId: number;
    WorkType: string;
    WoCategory: string;
}
export class Logo {
    fileName: string;
    filePath: string;
    attachment: string;
}

export class FormsEntity {
    ChklistMastId: number;
    ChklistName: string;
    IsActive: number;
    CustomerTypeId: number;
    Description: string;
}

export class CustomerTypeForms {
    Forms: FormsEntity[] = [];
    CustomerTypeForm: FormsEntity[] = [];
}


export class SaveCustomerTypeForm {
    CompanyId: number;
    FormId: number;
    CustomerTypeId: number;
    LoginId: number;
}
export class CustomerTypeContractList {
    ContractId: number;
    companyId: number;
    CustomerTypeId: number;
    ContractNo: string;
    ContractStartDate: string;
    ContractEndDate: string;
    ContractTypeId: number;
    ContractType: string;
    ContractAmount: any;
    Notes: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: Date;
    LastChangedBy: number;
    LastUpdate: Date;
    InActive: string;
    EventName: string;
}
export class RefConfigDtl {
    ConfigDtlId: number;  
    Description : string;
}
